
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ShopFrontAwningsPage() {

  return (
      GenericProductPage(getProductByID(58),toAwning)
  )
}
